/* Copyright (c) 2026 Xperi. All Rights Reserved. */
export enum PlayerCarouselFocusedField {
  ACTIONS = "actions",
  CAROUSELS = "carousels"
}
